import {api} from '@/api/factory';

class Auth {
    token: string | null= null;

    constructor() {}

    login(email?:string, password?:string) {
        return api.post('/v1/login-cm', {
            email: email,
            password: password
        })
    }

    logout() { {
         return api.post('/v1/logout')
    }}
}

export default Auth